import {Controller} from "@hotwired/stimulus"

export class ImageCycleController extends Controller {
    static values = {
        sources: Array,
        interval: {type: Number, default: 10}
    }

    connect() {
        this.index = 0
        this.timer = setInterval(() => this.advance(), this.intervalValue * 1000)
    }

    advance() {
        if (this.sourcesValue.length < 2) return
        this.index = (this.index + 1) % this.sourcesValue.length
        this.element.src = this.sourcesValue[this.index]
    }

    disconnect() {
        clearInterval(this.timer)
    }
}
